import COMPANY from "./company.json";

export const POSITIONING = COMPANY.positioning;
export const BROCHURE = COMPANY.brochure;

export const LOGO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_eram-futures/artifacts/avbiavsq_image.png";
export const LOGO_WHITE = `${process.env.PUBLIC_URL}/eram-logo-white.png`;

export const BG = {
  hero: `${process.env.PUBLIC_URL}/images/connected-operations.webp`,
  industries: `${process.env.PUBLIC_URL}/images/industrial-operations.webp`,
  team: `${process.env.PUBLIC_URL}/images/collaboration.webp`,
};

export const CONTACT = COMPANY.contact;

export const PARENT = {
  name: "ERAM HOLDINGS",
  url: "https://www.eramholdings.com",
  blurb:
    "ERAM DIGITAL is the digital and technology arm of ERAM HOLDINGS — a diversified multinational conglomerate that began operations in the 1990s in India and grew into a global group headquartered in Al Khobar, Saudi Arabia.",
  facts: [
    "12,000+ direct employees from 66 nationalities",
    "40+ subsidiary companies",
    "125+ offices across 16 countries in Asia & Europe",
    "9 business verticals",
  ],
  verticals: [
    "Human Capital Management (HCM)",
    "R&D and Manufacturing (Power Electronics)",
    "Travel & Tourism",
    "Healthcare",
    "Industrial Support Services",
    "Automotive",
    "Real Estate & Investments",
    "Training & Skill Development",
    "Information Technology (ERAM DIGITAL)",
  ],
  groupValues: [
    "Creative teamwork",
    "Social responsibility",
    "Customer-first mindset",
    "Entrepreneurial spirit",
    "ISO-certified quality",
    "ESG commitment",
  ],
};

export const NAV = [
  { key: "home", path: "/" },
  { key: "about", path: "/about" },
  { key: "services", path: "/services" },
  { key: "industries", path: "/industries" },
  { key: "cases", path: "/case-studies" },
  { key: "careers", path: "/careers" },
  { key: "contact", path: "/contact" },
];

export const PILLARS = [
  {
    id: "ai-data",
    name: "AI & Data Solutions",
    tagline: "Intelligence you can put to work.",
    icon: "brain",
    summary:
      "From generative and agentic AI to enterprise data platforms and decision intelligence — we help you turn data into clear, measurable business results.",
    capabilities: [
      "Generative & agentic AI copilots",
      "Machine learning & MLOps",
      "Modern data platforms & lakehouses",
      "Advanced analytics & BI",
      "Intelligent process automation",
      "Decision intelligence & forecasting",
    ],
    outcome: "Faster decisions, automated workflows, and new AI-driven products.",
    image:
      "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "digital-transformation",
    name: "Digital Transformation",
    tagline: "Modernize with momentum.",
    icon: "layers",
    summary:
      "Strategy, cloud migration, integration and legacy modernization — engineered to reduce cost and unlock scale, the Vision 2030 way.",
    capabilities: [
      "Digital strategy & operating models",
      "Cloud migration (AWS · Azure · GCP)",
      "Enterprise systems integration",
      "Legacy modernization & re-platforming",
      "Change management & enablement",
    ],
    outcome: "Lower operating cost, scalable infrastructure, future-ready operations.",
    image:
      "https://images.pexels.com/photos/37730211/pexels-photo-37730211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "software-product",
    name: "Software & Product Development",
    tagline: "Ship products that matter.",
    icon: "code",
    summary:
      "Custom web, mobile and SaaS platforms built end to end — with clear product thinking, robust engineering and a high bar for quality.",
    capabilities: [
      "Custom web application development",
      "Native & cross-platform mobile apps",
      "Multi-tenant SaaS platforms",
      "Product design & UX engineering",
      "API & microservices architecture",
    ],
    outcome: "Market-ready products shipped with quality, speed and scale.",
    image:
      "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHBlb3BsZSUyMG1vZGVybiUyMG9mZmljZSUyMHRlY2h8ZW58MHx8fHwxNzg3MDI2MTI4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "managed-it-talent",
    name: "Managed IT & Talent",
    tagline: "Always on. Always ready.",
    icon: "shield",
    summary:
      "Managed services, IT support and specialized tech staffing — reliable operations and instant access to the right expertise.",
    capabilities: [
      "24/7 managed IT & infrastructure",
      "Application support & maintenance",
      "Specialized technology staffing",
      "Dedicated resource augmentation",
      "Cybersecurity operations support",
    ],
    outcome: "Reliable operations and instant access to specialized talent.",
    image:
      "https://images.pexels.com/photos/17483910/pexels-photo-17483910.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const STATS = [
  { value: 12000, suffix: "+", label: "Group employees" },
  { value: 40, suffix: "+", label: "Group companies" },
  { value: 16, suffix: "", label: "Group country footprint" },
  { value: 30, suffix: "+", label: "Years of heritage" },
];

export const INDUSTRIES = [
  { name: "Finance", icon: "landmark", value: "Risk intelligence, fraud detection, and compliant digital banking experiences." },
  { name: "Government", icon: "building", value: "Citizen services, secure data platforms, and Vision 2030-aligned modernization." },
  { name: "Healthcare", icon: "heart-pulse", value: "Connected patient data, clinical AI, and interoperable health platforms." },
  { name: "Retail", icon: "shopping-bag", value: "Personalization engines, unified commerce, and demand forecasting." },
  { name: "Energy", icon: "zap", value: "Predictive maintenance, IoT telemetry, and operational decision intelligence." },
  { name: "Telecom", icon: "radio-tower", value: "Network analytics, self-service platforms, and customer experience automation." },
];

export const CLIENTS = [
  "AWS", "Microsoft Azure", "Google Cloud", "Kubernetes", "Databricks",
  "Snowflake", "OpenAI", "MongoDB", "Docker", "Terraform",
];

export const VALUES = [
  { title: "Outcomes over output", desc: "We measure success in real business results, not lines of code.", icon: "target" },
  { title: "Practical & rigorous", desc: "Clear thinking and disciplined delivery on every engagement.", icon: "sparkles" },
  { title: "People first", desc: "Technology in service of people — clients, teams and communities.", icon: "users" },
  { title: "Regional commitment", desc: "Proud to support the Gulf's digital and economic ambitions.", icon: "globe" },
];

export const ROLES = [];

export const BENEFITS = [
  "Practical problem-solving",
  "Collaboration across disciplines",
  "Learning and knowledge sharing",
  "Responsible technology delivery",
  "Understanding our customers' operations",
  "Clear communication and accountability",
];

export const PROCESS = BROCHURE.process;

// UI chrome translations (EN + AR scaffold)
export const TRANSLATIONS = {
  en: {
    nav: { home: "Home", about: "About", services: "Services", industries: "Industries", cases: "Case Studies", careers: "Careers", contact: "Contact" },
    cta: { consult: "Book a consultation", talkHuman: "Talk to a human", explore: "Explore services", getStarted: "Start a project", viewAll: "View all" },
    footer: { tagline: POSITIONING, company: "Company", solutions: "Solutions", resources: "Resources", newsletter: "Newsletter", newsletterDesc: "Our newsletter is coming soon. For now, please use the contact page to reach our team.", subscribe: "Subscribe", rights: "All rights reserved.", legal: "Legal" },
    era: { title: "ERA", subtitle: "ERAM DIGITAL AI Assistant", placeholder: "Ask ERA anything…", online: "Online", send: "Send", startersLabel: "Try asking" },
  },
  ar: {
    nav: { home: "الرئيسية", about: "من نحن", services: "الخدمات", industries: "القطاعات", cases: "دراسات الحالة", careers: "الوظائف", contact: "تواصل معنا" },
    cta: { consult: "احجز استشارة", talkHuman: "تحدث مع مختص", explore: "استكشف الخدمات", getStarted: "ابدأ مشروعك", viewAll: "عرض الكل" },
    footer: { tagline: "الذراع التقني لمجموعة إرم القابضة — نحوّل التقنيات الناشئة إلى نتائج ملموسة في الخليج.", company: "الشركة", solutions: "الحلول", resources: "المصادر", newsletter: "النشرة البريدية", newsletterDesc: "النشرة البريدية قريباً. للتواصل الآن، يرجى استخدام صفحة التواصل.", subscribe: "اشترك", rights: "جميع الحقوق محفوظة.", legal: "الشؤون القانونية" },
    era: { title: "ERA", subtitle: "المساعد الذكي لإرم ديجيتال", placeholder: "اسأل ERA أي شيء…", online: "متصل", send: "إرسال", startersLabel: "جرّب أن تسأل" },
  },
};
